const insuranceSpecialDateTypes = [
  'Date Last Seen',
  'Acute Manifest Date',
  'Accident Date',
  'Initial Treatment Date',
  'Last Menstrual Period',
  'Last X-Ray Date',
  'Assumed Care Date',
  'Relinquished Care Date',
  'Hearing and Vision Presctiption Date',
  'Authorized Return to Work Date',
  'First Contact Date',
  'Patient Death Date',
];

export default insuranceSpecialDateTypes;



// WEBPACK FOOTER //
// ./src/config/insuranceSpecialDateTypes.js